<template>
  <header class="bg-white border-b border-gray-200 shadow-sm fixed w-full z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <nav class="flex items-center justify-between h-22">
        <a href="/" class="items-center space-x-2">
          <img src="/img/logo.png" alt="" class="h-10 m-auto"><span class="text-gray-600 font-regular text-[12px]">Gestão de Tráfego Pago</span>
        </a>
        <ul class="hidden md:flex space-x-6 text-gray-600">
          <li><a href="#services" class="hover:text-blue-600">Serviços</a></li>
          <li><a href="#benefits" class="hover:text-blue-600">Benefícios</a></li>
          <li><a href="#pricing" class="hover:text-blue-600">Planos</a></li>
          <li><a href="#testimonials" class="hover:text-blue-600">Depoimentos</a></li>
        </ul>
        <a
          href="https://wa.me/+5519999041297" target="_blank"
          class="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-sm text-sm hover:bg-blue-700"
        >
          Fale Conosco
        </a>
      </nav>
    </div>
  </header>
</template>
